import React, {Fragment} from 'react'
import { Row, Col } from 'react-bootstrap'

const Title = ({title, descripcion}) => {
  const style = {
    fontSize: 2.5+"rem",
    fontWeight: 300,
    lineHeight: 1.2
  }
  
  return (
    <Fragment>
    <Row>
      <Col lg="auto">
        <span className=" d-inline ml-4" style={style}>
          {title}  
        </span>        
      </Col>
      <Col className="align-self-end" >
        {descripcion}
      </Col>
    </Row>
      <hr className="mb-4"/>
      </Fragment>
  )
}

export default Title
